import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import { getEventsList } from './redux/actions/events-actions-creator';
import { getLawyersList } from './redux/actions/lawyers-actions-creator';
import getStatesList from './redux/actions/states-action-creator';
import getRepresentativesList from './redux/actions/representatives-action-creator';
import getVoteLocationsList from './redux/actions/vote-locations-actions-creator';
import { getMenuList } from './redux/actions/menu-list-actions-creator';
import getPageList from './redux/actions/page-list-actions-creator';
import getCopiesList from './redux/actions/copies-list-actions-creator';

import styles from './App.module.scss';

import Home from './pages/home/Home';
import ProtestsList from './pages/protests-list/ProtestsList';
import Lawyers from './pages/lawyers/Lawyers';
import WhatToBring from './pages/what-to-bring/WhatToBring';
import Header from './components/header/Header';
import BottomTabs from './components/bottom-tabs/BottomTabs';
import EventDetailPage from './components/EventDetailPage/EventDetailPage';
import DynamicPagesList from './pages/dynamic-pages-list/DynamicPagesList';
import SideMenu from './components/side-menu/SideMenu';
import ContentNotFound from './components/content-not-found/ContentNotFound';

function App() {
  const [isSideMenuOpened, setIsSideMenuOpened] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMenuList());
    dispatch(getPageList());
    dispatch(getEventsList());
    dispatch(getStatesList());
    dispatch(getLawyersList());
    dispatch(getRepresentativesList());
    dispatch(getVoteLocationsList());
    dispatch(getCopiesList());
  }, [dispatch]);

  const handleOpenSideMenu = () => {
    setIsSideMenuOpened(!isSideMenuOpened);
  };

  return (
    <div className={styles.app}>
      <Router>
        <Header
          isSideMenuOpened={isSideMenuOpened}
          onMenuClick={handleOpenSideMenu}
        />
        <SideMenu
          isOpened={isSideMenuOpened}
          onMenuButtonClick={handleOpenSideMenu}
        />
        <div className={styles.appContent}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/lawyers">
              <Lawyers />
              <BottomTabs />
            </Route>
            <Route path="/what-to-bring">
              <WhatToBring />
              <BottomTabs />
            </Route>
            <Route exact path="/protests">
              <ProtestsList />
              <BottomTabs />
            </Route>
            <Route
              exact
              path="/:id"
              render={(props) => <DynamicPagesList {...props} />}
            />
            <Route
              path="/*/:id"
              render={(props) => <EventDetailPage {...props} />}
            />
            <Route path="*">
              <ContentNotFound />
            </Route>
          </Switch>
        </div>

        {/* <BottomTabs /> */}
      </Router>
    </div>
  );
}

export default App;
